import { useI18n } from '../../contexts/I18nContext';

/**
 * Compact language switcher — shown in sidebar or topbar.
 */
const LanguageSwitcher = ({ variant = 'dropdown' }) => {
  const { lang, changeLang, languages } = useI18n();

  if (variant === 'pills') {
    return (
      <div className="d-flex gap-1">
        {languages.map((l) => (
          <button key={l.code} onClick={() => changeLang(l.code)}
            className={`btn btn-sm ${lang === l.code ? 'btn-warning' : 'btn-outline-secondary'}`}
            style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}
            title={l.name}
          >
            {l.flag} {l.code.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  return (
    <select
      value={lang}
      onChange={(e) => changeLang(e.target.value)}
      className="form-select form-select-sm"
      style={{ width: 'auto', fontSize: '0.8rem', padding: '0.25rem 1.5rem 0.25rem 0.5rem' }}
    >
      {languages.map((l) => (
        <option key={l.code} value={l.code}>{l.flag} {l.nativeName}</option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
